import { makeStyles } from '@mui/styles';

const options = {
  name: 'doughnut-chart'
};

const useStyles = makeStyles(
  () => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    indicator: {
      width: 16,
      height: 8,
      borderRadius: 7
    }
  }),
  options
);

export default useStyles;
